import React from 'react';
import { ColorBadgeTW } from 'tailwindComponents/badgeTW/BadgeTW';
import { useGetProgressionsQuery } from '../../../../API/order/signingAppointment/SigningAppointmentAPI';
import {
  getSigSyncProgressionLineLabel,
  ISigSyncProgressionLine,
} from '../../../../types/signingAppointment/ISigSyncProgressionLine';
import classNames from 'classnames';
import { useParams } from 'react-router-dom';
import { UUID } from '../../../../types/shared/UUID';
import { getCurrentSigSyncProgressionStatus } from '../utilities/getCurrentSigSyncProgressionStatus';

export const BadgeColorsByProgression: Record<ISigSyncProgressionLine, string> = {
  CANCELED: 'bg-red-100 text-red-800',
  COMPLETE: 'bg-green-100 text-green-800',
  NOT_SIGNED: 'bg-red-100 text-red-800',
  PREPARING_DOCS: 'bg-lightBlue-100 text-lightBlue-800',
  REQUESTING: 'bg-lightBlue-100 text-lightBlue-800',
  SIGNING: 'bg-lightBlue-100 text-lightBlue-800',
};

export interface ISignatureSyncProgressionBadgeProps {
  appointmentId: string;
  appointmentOrderId?: string;
}

export const SignatureSyncProgressionBadge: React.FC<ISignatureSyncProgressionBadgeProps> = ({
  appointmentId,
  appointmentOrderId,
}) => {
  const { orderId } = useParams<{ orderId: UUID }>();

  const { data: progressions } = useGetProgressionsQuery({
    id: appointmentId,
    orderId: orderId ?? appointmentOrderId,
  });
  if (!progressions || Object.keys(progressions).length === 0) {
    return <></>;
  }

  const progressionStatus = getCurrentSigSyncProgressionStatus(progressions);
  const progressionStatusLabel = getSigSyncProgressionLineLabel(progressionStatus!);
  return (
    <ColorBadgeTW className={classNames(BadgeColorsByProgression[progressionStatus!])}>
      {progressionStatusLabel}
    </ColorBadgeTW>
  );
};
